"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TravelWillingnessLabels = exports.WorkTypePreferenceLabels = void 0;
exports.WorkTypePreferenceLabels = {
    PER_DIEM: 'Some days here and there',
    LONG_TERM: "I'm looking for a long term opportunity",
    OPEN_TO_ANYTHING: "I'm open to anything!",
};
exports.TravelWillingnessLabels = {
    WILLING: 'Yes',
    WILLING_WITH_STIPEND: 'Yes, but I need a stipend',
    NOT_WILLING: 'No',
};
//# sourceMappingURL=facility-interest-labels.js.map